<template>
    <div class="p-relative">

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :item-class="itemRowBackground"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document' })">
                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.createdate`]="{ item }">
                        <div>{{ $moment(item.createdate).format('DD.MM.YYYY HH:mm:ss') }}</div>
                    </template>

                    <template v-slot:[`item.outdate`]="{ item }">
                        <div>{{ $moment(item.outdate).format('DD.MM.YYYY') }}</div>
                    </template>

                    <template v-slot:[`item.correspondent`]="{ item }">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.correspondent">
                                {{ item.correspondent }}
                            </div>
                        </div>
                    </template>
                    
                    <template v-slot:[`item.theme`]="{ item }">
                        <div class="elipsis-text-wrap">                        
                            <v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.theme">
                                    {{ item.theme }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import { mapGetters } from "vuex";

export default {
    name: "ChancelleryIncomings",
    props: {
        search: {
            type: String,
            default: ""
        },
        status: {
            type: String,
            default: ""
        }
    },
    columnIndex:  {
        'createdate': 7,
        'outnumber': 2,
        'correspondent': 5,
        'theme': 6,
        'outdate': 3,
    },
    computed: {
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        headers() {
            return [
                { text: this.$t("Дата_поступления"), value: 'createdate', width: '150px' },
                { text: this.$t("Исх_№"), value: 'outnumber', width: '150px' },
                { text: this.$t("Дата_исходящего"), value: 'outdate', width: '140px' },
                { text: this.$t("Корреспондент"), value: 'correspondent', width: '20%' },
                { text: this.$t("Краткое_содержание"), value: 'theme'}
            ];
        },
        extendedFilter(){
            return this.$store.getters['chancellery/lists/incomings/getExtendedFilter']
        },
        options: {
            get: function() {
                return this.$store.getters['chancellery/lists/incomings/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('chancellery/lists/incomings/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                RegState: this.status,
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedFilter)
            }
        },
    },
    data() {
        return {
            collection: "Avrora.Objects.Modules.Docflow.DocflowObjects.IncomingDocument",
            loading: false,

            entities: [],
            total: 0,

            paginationPageCount: 0,

            filterDataSource: null
        }
    },
    methods: {
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
                
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;
            
            let response = await httpAPI({
                url: `/api/chancellary/list?filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;            
            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, RegState, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? true : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "createdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 7;

            return { SearchStr, RegState, DocType: this.collection, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, ...extendedFilterData };
        }
    },
    watch: {
        filter: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    },
    async created() {
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    }
}
</script>